// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"3b6a3cbb","104":"bf2319c3","814":"01384310","819":"95949467","999":"5ec92368"}[chunkId] + ".chunk.css";
};